/**
 * フィーチャーフラグユーティリティ
 *
 * 機能の有効/無効を環境変数で制御するためのヘルパー
 */

/**
 * フィーチャーフラグの状態
 */
export const featureFlags = {
  /**
   * 銀行振込機能が有効かどうか
   * 環境変数 VITE_ENABLE_BANK_TRANSFER で制御
   * デフォルト: false（無効）
   */
  bankTransfer: import.meta.env.VITE_ENABLE_BANK_TRANSFER === 'true',

  /**
   * 銀行振込の選択UIを表示するかどうか
   * 環境変数 VITE_ENABLE_BANK_TRANSFER_SELECTION で制御
   * デフォルト: false（無効）
   */
  bankTransferSelection: import.meta.env.VITE_ENABLE_BANK_TRANSFER_SELECTION === 'true',

  /**
   * サブスクリプション機能が有効かどうか
   * 環境変数 VITE_ENABLE_SUBSCRIPTION_FEATURES で制御
   */
  subscriptionFeatures: import.meta.env.VITE_ENABLE_SUBSCRIPTION_FEATURES !== 'false',

  /**
   * エンタープライズ/プレミアムプランが有効かどうか
   * 環境変数 VITE_ENABLE_ENTERPRISE_PREMIUM で制御
   */
  enterprisePremium: import.meta.env.VITE_ENABLE_ENTERPRISE_PREMIUM === 'true',

  /**
   * QRコードシール印刷機能が有効かどうか
   * 環境変数 VITE_ENABLE_QR_LABEL_PRINTING で制御
   * デフォルト: true（無効化する場合は false）
   */
  qrLabelPrinting: import.meta.env.VITE_ENABLE_QR_LABEL_PRINTING !== 'false',
} as const;

/**
 * 特定のフィーチャーが有効かどうかをチェック
 */
export function isFeatureEnabled(feature: keyof typeof featureFlags): boolean {
  return featureFlags[feature];
}
